export function LogoFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-13.435.698c-.7-2.145-1.02-3.046-1.408-3.876a6.616 6.616 0 00-.314-.598c-.115.372-.195.914-.227 1.612-.083 1.786.15 4.454.703 7.978a1.2 1.2 0 11-2.37.372c-.577-3.67-.822-6.48-.73-8.46.049-1.065.195-1.916.46-2.575.34-.846.907-1.434 1.708-1.618.757-.174 1.429.129 1.966.71.352.38.664.894.977 1.561.447.955.782 1.899 1.516 4.15l.006.017c.677 2.073.98 2.938 1.356 3.766.214.474.41.818.574 1.02l.012.014a.37.37 0 00.131-.121c.153-.205.287-.582.372-1.112.171-1.07.123-2.58-.105-4.448-.259-2.12-.669-3.788-1.216-4.994a1.2 1.2 0 012.185-.991c.661 1.456 1.127 3.351 1.413 5.694.253 2.073.307 3.776.092 5.118-.14.881-.399 1.607-.819 2.17A2.688 2.688 0 0114.63 19.2c-.687 0-1.242-.355-1.709-.929-.317-.389-.607-.898-.9-1.544-.425-.94-.743-1.845-1.45-4.011l-.006-.018z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
